import { Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

export const usePayrollPaywallingGuard = () => {
  const { company } = useCurrentSession()
  const { featureAvailability, loading } = useFeatureAvailability(
    Features.payroll_management,
    company.id
  )

  // If the company is still on the old packaging, we want them to still access payroll
  // (so paywalls are not enabled)
  if (!hasFeature('dev_packaging_paywalls')) {
    return {
      isPayrollAvailable: hasFeature('payroll_bundle'),
      loadingFeatures: loading,
    }
  }

  return {
    isPayrollAvailable: featureAvailability.available,
    loadingFeatures: loading,
  }
}
